import { useEffect, useState, useContext } from "react";
import Select from 'react-select';
import { ddStyles } from "../utils/CommonStyles.js";
import FetchUtil from "../utils/FetchUtil";
import { useNavigate } from "react-router-dom";
import UserContext from "../contexts/UserContext";

function PartnerLocationTableRow({ index, partnerKey, buyerKey, loginId, handleSubmit, setError, t, setAdd, oddIdx }) {
	const navigate = useNavigate();
	const [locationOptions, setLocationOptions] = useState([]);
	const [locationLoaded, setLocationLoaded] = useState(false);
	const [locationSelected, setLocationSelected] = useState({ name: "locationKey", label: "", value: 0 });
	const [isSubmit, setIsSubmit] = useState(false);
	const userCtx = useContext(UserContext);
	let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;
	
	useEffect(() => {
		fetchPartnerLocations(partnerKey);
	}, []);
	const locationHandler = (selectedOption, action) => {
		let locationKey = selectedOption ? selectedOption.value : 0;
		let locationName = selectedOption ? selectedOption.label : "";
		setLocationSelected({ ...locationSelected, label: (locationName), value: locationKey });
	}

	function fetchPartnerLocations(partnerKey) {
		setError("");
		if (!partnerKey || partnerKey === 0) {
			return;
		}

		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", getAll: false,
				supplierKey: partnerKey,
				buyerKey:buyerKey,
				loginId:loginId,
				userCompanyId: userCompanyId
			}),
		};
		try {
			FetchUtil.fetchAPI("GetPartnerLocations", "/Service/CompanyService/GetPartnerLocations", requestOptions, retrieveWorkLocationSuccess, retrieveWorkLocationFail);
		} catch (error) {
			throw new Error(error.message);
		}
	}

	function retrieveWorkLocationFail(redirect) {
		if (redirect) {
			navigate("/");
		}
		setError(t("error.locNotRetrieved"));
	}

	function retrieveWorkLocationSuccess(responseData) {
		let getPartnerLocationResponse;
		if (responseData) {
			getPartnerLocationResponse = responseData.getPartnerLocationResponse;
			if (getPartnerLocationResponse && getPartnerLocationResponse.errorCode === "0") {
				setLocationValues(getPartnerLocationResponse.locations.slice());
			} else if (getPartnerLocationResponse && getPartnerLocationResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (getPartnerLocationResponse) {
				setLocationValues([]);
				setError(t("error.error") + " " + getPartnerLocationResponse.errorMessage);
			} else {
				setLocationValues([]);
				setError(t("error.system.fetch"));
			}
		}
	}

	function setLocationValues(locationObj) {
		let locationValue = {};
		let locationOptionList = [];
		locationOptionList.push({ label: "", value: 0 });
		if (locationObj && locationObj.length > 0) {
			locationObj.map((aLoc, idx) => {
				locationValue.label = aLoc.locationName + "-" + aLoc.departmentName;
				locationValue.value = aLoc.locationKey;
				locationOptionList.push(locationValue);
				locationValue = {};
			});
			
		}
		setLocationOptions(locationOptionList);
		setLocationSelected({ ...locationSelected, label: "", value: 0 });
		setLocationLoaded(true);
	}


	function submitComplete() {
		setIsSubmit(false);
	}
	function submitRow() {
		setError("");
		setIsSubmit(true);
		let initialValues = {
			locationKey: locationSelected.value,
			partnerKey: partnerKey
		};

		if (!partnerKey || partnerKey === 0) {
			setError(t("error.suplrReqd"));
			setIsSubmit(false);
		} else if (!locationSelected.value || locationSelected.value === 0) {
			setError(t("error.locNameReqd"));
			setIsSubmit(false);
		} else {
			handleSubmit(1, initialValues, submitComplete);
		}

	}
	function submitCancel() {
		setError("");
		setAdd(false);
	}
	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				{locationLoaded ? <Select
					name="locationKey"
					options={locationOptions}
					onChange={locationHandler}
					placeholder={""}
					value={locationSelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="locationKey-input"
					styles={ddStyles}
				/>
				: <></>}
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				{(locationOptions && locationOptions.length >0) ?
				(<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>) 
				:
				(<></>)
				}
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button></td>
		</tr>
	)

}
export default PartnerLocationTableRow;